export const GET_ALL_BONCOMMANDE_REQUEST = "GET_ALL_BONCOMMANDE_REQUEST";
export const GET_ALL_BONCOMMANDE_SUCCESS = "GET_ALL_BONCOMMANDE_SUCCESS";
export const GET_ALL_BONCOMMANDE_FAIL = "GET_ALL_BONCOMMANDE_FAIL";

export const GET_BONCOMMANDE_REQUEST = "GET_BONCOMMANDE_REQUEST";
export const GET_BONCOMMANDE_SUCCESS = "GET_BONCOMMANDE_SUCCESS";
export const GET_BONCOMMANDE_FAIL = "GET_BONCOMMANDE_FAIL";

export const ADD_BONCOMMANDE_REQUEST = "ADD_BONCOMMANDE_REQUEST";
export const ADD_BONCOMMANDE_SUCCESS = "ADD_BONCOMMANDE_SUCCESS";
export const ADD_BONCOMMANDE_FAIL = "ADD_BONCOMMANDE_FAIL";

export const UPDATE_BONCOMMANDE_REQUEST = "UPDATE_BONCOMMANDE_REQUEST";
export const UPDATE_BONCOMMANDE_SUCCESS = "UPDATE_BONCOMMANDE_SUCCESS";
export const UPDATE_BONCOMMANDE_FAIL = "UPDATE_BONCOMMANDE_FAIL";

export const DELETE_BONCOMMANDE_REQUEST = "DELETE_BONCOMMANDE_REQUEST";
export const DELETE_BONCOMMANDE_SUCCESS = "DELETE_BONCOMMANDE_SUCCESS";
export const DELETE_BONCOMMANDE_FAIL = "DELETE_BONCOMMANDE_FAIL";

export const ADD_BCARTICLE_REQUEST = "ADD_BCARTICLE_REQUEST";
export const ADD_BCARTICLE_SUCCESS = "ADD_BCARTICLE_SUCCESS";
export const ADD_BCARTICLE_FAIL = "ADD_BCARTICLE_FAIL";

export const GET_BCARTICLE_REQUEST = "GET_BCARTICLE_REQUEST";
export const GET_BCARTICLE_SUCCESS = "GET_BCARTICLE_SUCCESS";
export const GET_BCARTICLE_FAIL = "GET_BCARTICLE_FAIL";

export const UPDATE_BCARTICLE_REQUEST = "UPDATE_BCARTICLE_REQUEST";
export const UPDATE_BCARTICLE_SUCCESS = "UPDATE_BCARTICLE_SUCCESS";
export const UPDATE_BCARTICLE_FAIL = "UPDATE_BCARTICLE_FAIL";

export const DELETE_BCARTICLE_REQUEST = "DELETE_BCARTICLE_REQUEST";
export const DELETE_BCARTICLE_SUCCESS = "DELETE_BCARTICLE_SUCCESS";
export const DELETE_BCARTICLE_FAIL = "DELETE_BCARTICLE_FAIL";
